<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/'" [showBanner]="false"></fgb-page-header>

<!--Sub Nav-->
<ng-container *ifScreenSize="screenType.Mobile">
  <div class="container">
    <fgb-payment-nav></fgb-payment-nav>
  </div>
</ng-container>

<div class="container mt-4">
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
